<template>
  <main class="py-10 px-4 max-w-7xl mx-auto">
    <h2 class="text-3xl font-bold text-center mb-10">Our Gallery</h2>

    <!-- Masonry-style staggered grid -->
    <div class="columns-1 sm:columns-2 md:columns-3 gap-4">
      <div
        v-for="(image, index) in images"
        :key="index"
        class="mb-4 break-inside-avoid"
      >
        <img
          :src="image"
          alt="Gallery image"
          class="w-full rounded-xl object-cover shadow-md hover:scale-105 transition-transform duration-300"
        />
      </div>
    </div>
  </main>
</template>

<script>
export default {
  data() {
    return {
        images: [
        require('../assets/images/Lisa_23.jpg'),
        require('../assets/images/Lisa_25.jpg'),
        require('../assets/images/Lisa_24.jpg'),
        require('../assets/images/Lisa_26.jpg'),
        require('../assets/images/Lisa_45.jpg'),
        require('../assets/images/Lisa_48.jpg'),
        require('../assets/images/Lisa_46.jpg'),
        require('../assets/images/Lisa_44.jpg'),
        require('../assets/images/Lisa_27.jpg'),
        require('../assets/images/Lisa_43.jpg'),
        require('../assets/images/Lisa_49.jpg'),
        require('../assets/images/Lisa_47.jpg'),       
      ],
    };
  },
};
</script>

<style scoped>
.break-inside-avoid {
  break-inside: avoid;
}
</style>
